import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {MovingDirection, WizardComponent} from "ng2-archwizard/dist";
import {FileService} from "../../../../core/visbos-core/http/file.service";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {TouchStocktakingService} from "../touch-stocktaking.service";
import {FormGroup} from "@angular/forms";
import {StocktakingService} from "../../../../store-management/services/stocktaking/stocktaking.service";
import {map} from "rxjs/operators";
import {GenericModalComponent} from "../../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {Subscription} from "rxjs/Subscription";
import {Observable} from "rxjs/Observable";
import {MessageType} from "../../../../shared/redux-store/session";

@Component({
  selector: 'vb-stocktaking-wizard',
  templateUrl: './stocktaking-wizard.component.html',
  styleUrls: ['./stocktaking-wizard.component.css']
})
export class StocktakingWizardComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit {

  MovingDirection;

  @ViewChild(WizardComponent)
  wizard: WizardComponent;

  @ViewChild('continueStocktakingModal')
  continueStocktakingModal: GenericModalComponent;

  currentStep: number;

  private param$;

  private latestStocktakingSub: Subscription;

  canExitDepotPageProxy = (direction: MovingDirection) => this.canExitDepotPage.apply(this, [direction]);
  canExitStocktakingPageProxy = (direction: MovingDirection) => this.canExitStocktakingPage.apply(this, [direction]);
  canExitFinalizePageProxy = (direction: MovingDirection) => this.canExitFinalizePage.apply(this, [direction]);

  genPDF$;
  sealStocktaking$;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private tsService: TouchStocktakingService,
              private stocktakingService: StocktakingService,
              private fileService: FileService,
              private loc: Location,
              private router: Router,
              private route: ActivatedRoute) {
    super(sessionActions, cd);
    this.MovingDirection = MovingDirection;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.resetComponent();

    this.param$ = this.route.params.pipe(map(params => params.stocktakingCuid));
    this.addSubscription(this.tsService.loadStocktaking(this.param$).subscribe());

    this.addComponentData(this.tsService.latestStocktaking$);
    this.latestStocktakingSub = this.tsService.latestStocktaking$.subscribe(res => {
      if (!this.tsService.currentStocktaking && !this.tsService.currentStocktakingCuid$.value) {
        if (this.tsService.latestStocktaking) {
          this.continueStocktakingModal.show();
        }
      }
    });
    this.addSubscription(this.latestStocktakingSub);

  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    setTimeout(() => {
      this.tsService.initStocktakingData();
    });
    this.addSubscription(this.param$.subscribe(p => {
      if (this.wizard && p) {
        this.tsService.currentStocktakingCuid$.next(p);
        this.wizard.navigation.goToStep(1);
      }
    }));
  }


  resetComponent(): void {
    this.tsService.reset();
    super.resetComponent();
  }

  onStepChanged() {
    if (!this.wizard) {
      return 0;
    }
    this.currentStep = this.wizard.model.getIndexOfStep(this.wizard.model.currentStep);
  }

  onFinalStepEntered() {
    this.onStepChanged();
  }

  onExitInitPage(direction: MovingDirection) {
    if (!this.tsService.currentStocktaking && !this.tsService.currentStocktakingCuid$.getValue() && direction == MovingDirection.Forwards) {
      this.addSubscription(this.tsService.initStocktaking(this.getStocktakingInitControl().value).subscribe());
    }

    if (this.latestStocktakingSub) {
      this.latestStocktakingSub.unsubscribe();
    }
  }

  onEnterStocktakingPage(direction: MovingDirection) {
    this.onStepChanged();
    if (!this.tsService.currentStocktaking) {
      this.addSubscription(this.tsService.loadStocktaking(this.tsService.currentStocktakingCuid$).subscribe());
    }
  }

  onExitStocktakingPage(direction: MovingDirection) {
    if (direction == MovingDirection.Forwards) {

    }
  }

  onSealStocktakingClicked() {
    if (this.canSealStocktaking()) {
      this.sealStocktaking$ = this.tsService.sealStocktaking();
      this.addSubscription(this.sealStocktaking$.subscribe(res => {
        this.sessionActions.pushMessage("Die Medikamentenkontrolle wurde erfolgreich gespeichert und festgeschrieben!", MessageType.SUCCESS, "Medikamentenkontrolle")
        this.router.navigate(['/touch']);
      }, err => this.sessionActions.throwError(err, "Fehler beim Festschfreiben der Inventur!", "Medikamentenkontrolle")));
    }
  }

  onPrintChecklistClicked() {
    if (!this.canPrintChecklist()) {
      return;
    }
    this.genPDF$ = this.stocktakingService.generateStocktakingChecklistPDF(this.tsService.currentStocktaking.cuid);
    this.genPDF$.toPromise()
      .then(res => {
        let data = this.fileService.base64toBlob(res.data.stocktakingChecklistPdf, 'application/pdf', 512);
        this.fileService.printFile(data);
      })
      .catch(err => this.sessionActions.throwError(err));
  }

  onInitNewStocktakingClicked() {
    this.continueStocktakingModal.hide();
  }

  onContinueLastStocktakingClicked() {
    this.continueStocktakingModal.hide();
    this.tsService.currentStocktaking = this.tsService.latestStocktaking;
    this.tsService.currentStocktakingCuid$.next(this.tsService.latestStocktaking);
    this.wizard.navigation.goToStep(1);
  }

  isInitialized() {
    return this.tsService.isInitialized();
  }

  getCurrentStocktaking() {
    return this.tsService.currentStocktaking;
  }

  savingEntries: boolean = false;

  onSavingEntries(savingOp: Observable<any>) {
    this.savingEntries = true;
    this.addSubscription(savingOp.subscribe(res => {
      this.savingEntries = false;
    }));
  }

  canExitDepotPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {

      if (this.tsService.currentStocktakingCuid$.getValue()) {
        return true;
      }

      return this.tsService.initStocktakingControl && this.tsService.initStocktakingControl.valid;
    }

    return false;

  }

  canExitStocktakingPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      return true;
    } else {
      return true;
    }

  }

  canExitFinalizePage(direction: MovingDirection): boolean {
    if (direction == MovingDirection.Forwards) {
      return this.canSealStocktaking();
    } else {
      return true;
    }
  }


  canSealStocktaking(): boolean {
    return this.tsService.canSealStocktaking();
  }

  canPrintChecklist() {
    return this.tsService.currentStocktaking != null;
  }

  getStocktakingInitControl(): FormGroup {
    return this.tsService.initStocktakingControl;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getLatestStocktaking() {
    return this.tsService.latestStocktaking;
  }

  getNumberOfPinnedDownEntries() {
    if (!this.tsService.latestStocktaking) {
      return 0;
    }

    let noPinnedDown = this.tsService.latestStocktaking.stocktaking_entries.filter(e => e.pinned_down).length;
    let noAll = this.tsService.latestStocktaking.stocktaking_entries.length;

    return noPinnedDown + " / " + noAll;

  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-stocktaking/stocktaking-wizard/stocktaking-wizard.component.ts